// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3987 ? "a3319169" : chunkId) + "." + {"1056":"b94eaff86b953fe7","3987":"05fae8d158e45e56"}[chunkId] + ".js";
};